import React from 'react';

type Props = {
  children: React.ReactNode;
  title?: string;
};

export default function WithStylePortalWrapper({children, title}: Props) {
  const headRef = React.useRef<HTMLHeadElement>(null);

  React.useEffect(() => {
    if (!headRef.current) {
      return;
    }

    const head = headRef.current;
    const doc = head.ownerDocument!;

    document.querySelectorAll('style').forEach((srcStyle) => {
      const destStyle = doc.createElement('style');
      destStyle.textContent = srcStyle.textContent;
      head.appendChild(destStyle);
    });

    document.querySelectorAll('link').forEach((srcLink) => {
      if (srcLink.rel !== 'stylesheet') {
        return;
      }
      const destLink = doc.createElement('link');
      destLink.href = srcLink.href;
      destLink.rel = srcLink.rel;
      head.appendChild(destLink);
    });
  }, []);

  return (
    <>
      <head ref={headRef}>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
      </head>
      <body>{children}</body>
    </>
  );
}
